/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface BulkMoveJobFailure {
  job_candidate_id: string;
  reason: string;
}
